import { NumberField } from '@base-ui/react/number-field';
import type { ComponentPropsWithRef } from 'react';

import { cn } from '@/lib/utils';

import { NumberInputContextProvider, type NumberInputSize } from './NumberInputContext';

export type NumberInputProps = Omit<ComponentPropsWithRef<typeof NumberField.Root>, 'size'> & {
  size?: NumberInputSize;
};

const NumberInput = ({ ref, className, size = 'large', children, ...props }: NumberInputProps) => {
  return (
    <NumberInputContextProvider size={size}>
      <NumberField.Root
        ref={ref}
        data-slot="number-input"
        data-size={size}
        className={cn('group/number-input w-full', className)}
        {...props}
      >
        {children}
      </NumberField.Root>
    </NumberInputContextProvider>
  );
};

NumberInput.displayName = 'NumberInput';

export default NumberInput;
